import useGetMenuLinks from './useGetMenuLinks'
export default useGetMenuLinks
